import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Diamond, Zap, Skull, XCircle, Shield, Radio, Hexagon,
  Flag, Sparkles, Triangle, Grid3x3, Infinity as InfinityIcon, Settings,
  Briefcase, Upload, FileCode2
} from "lucide-react";

const GROUPS = [
  {
    label: "Engagement",
    items: [
      { to: "/engagements", label: "Engagements", icon: Briefcase },
      { to: "/import", label: "Import Findings", icon: Upload },
      { to: "/scans", label: "Scan Workers", icon: Radio, badge: "LIVE" },
      { to: "/nuclei-templates", label: "Nuclei Templates", icon: FileCode2 },
    ],
  },
  {
    label: "Attack Surface",
    items: [
      { to: "/recon", label: "Recon Engine", icon: Diamond },
      { to: "/pentest", label: "Pen Test Suite", icon: Zap, badge: "LIVE" },
      { to: "/red-team", label: "Autonomous RedTeam", icon: Skull },
      { to: "/exploit-lab", label: "Exploit Lab", icon: XCircle },
    ],
  },
  {
    label: "Defence & Monitor",
    items: [
      { to: "/blue-team", label: "AI Blue Team", icon: Shield },
      { to: "/soc-copilot", label: "SOC Copilot", icon: Radio, count: 3 },
      { to: "/threat-intel", label: "Threat Intelligence", icon: Hexagon },
      { to: "/incidents", label: "Incident Response", icon: Flag },
    ],
  },
  {
    label: "Governance",
    items: [
      { to: "/compliance", label: "Compliance Auto", icon: Sparkles },
      { to: "/ciso-advisor", label: "CISO Advisor AI", icon: Diamond },
      { to: "/risk", label: "Risk Scoring", icon: Triangle },
    ],
  },
  {
    label: "Platform",
    items: [
      { to: "/assets", label: "Asset Discovery", icon: Grid3x3 },
      { to: "/cyber-twin", label: "AI Cyber Twin", icon: InfinityIcon },
      { to: "/attack-surface", label: "3D Attack Surface", icon: Hexagon, badge: "NEW" },
      { to: "/configuration", label: "Configuration", icon: Settings },
    ],
  },
];

const Sidebar = () => {
  const { pathname } = useLocation();
  return (
    <aside
      data-testid="sidebar"
      className="w-64 shrink-0 border-r border-slate-800 bg-slate-950/60 backdrop-blur h-[calc(100vh-3rem)] sticky top-12 overflow-y-auto"
    >
      <nav className="py-6 pr-2">
        {GROUPS.map((g) => (
          <div key={g.label} className="mb-6">
            <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 px-6 mb-2">
              {g.label}
            </div>
            <ul className="space-y-1">
              {g.items.map(({ to, label, icon: Icon, badge, count }) => {
                const active = pathname === to;
                return (
                  <li key={to}>
                    <Link
                      to={to}
                      data-testid={`nav-${to.replace("/", "")}`}
                      className={[
                        "flex items-center gap-3 px-6 py-2 text-sm border-l-2 transition-all",
                        active
                          ? "border-cyan-400 bg-cyan-400/5 text-cyan-300 text-glow-cyan"
                          : "border-transparent text-slate-400 hover:text-slate-100 hover:bg-slate-900/40",
                      ].join(" ")}
                    >
                      <Icon className="h-4 w-4 shrink-0" strokeWidth={1.5} />
                      <span className="flex-1 truncate">{label}</span>
                      {badge && (
                        <span className="text-[9px] px-1.5 py-0.5 rounded-sm bg-rose-500/20 text-rose-300 border border-rose-500/40 font-bold">
                          {badge}
                        </span>
                      )}
                      {count != null && (
                        <span className="text-[10px] px-1.5 py-0.5 bg-amber-400/20 text-amber-300 border border-amber-400/40">
                          {count}
                        </span>
                      )}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
